import LegacyDeletableList from 'design-system/compatibility/LegacyDeletableList';
import {Template} from '../SendNotificationModal/types';

function TemplateList({templates, onDeleteTemplate}: {templates: Template[]; onDeleteTemplate: (id: string) => void}) {
  const handleSelect = (id: string) => {
    console.log(`Template ${id} selected`);
  };

  return (
    <LegacyDeletableList
      title="Templates"
      items={templates.map(template => ({id: template.template_id, label: template.template_name}))}
      onItemClick={handleSelect}
      onDeleteItem={onDeleteTemplate}
    />
  );
}

export default TemplateList;
